import request from '@/utils/request'

export function add(prescription) {
  return request({
    url: '/YaocaiAttribute/add',
    method: 'post',
    data: prescription
  })
}

export function edit(prescription) {
  return request({
    url: '/YaocaiAttribute/edit',
    method: 'post',
    data: prescription
  })
}
